import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ExportApi = createApi({
    reducerPath: "ExportApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API_URL + "/export",
        credentials: 'include',
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('_at') || null;
            if (token) {
                headers.set("Authorization", "Bearer " + token);
            }
            return headers;
        }
    }),
    tagTypes: ['Export'],
    endpoints: (builder) => ({
        exportOrders: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const queryString = params.toString();
                return `/orders${queryString ? `?${queryString}` : ''}`;
            },
            // Returns raw CSV text
            responseHandler: (response) => response.text()
        }),
        exportExpenses: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const queryString = params.toString();
                return `/expenses${queryString ? `?${queryString}` : ''}`;
            },
            responseHandler: (response) => response.text()
        }),
        exportSummary: builder.query({
            query: ({ from = '', to = '' } = {}) => {
                const params = new URLSearchParams();
                if (from) params.append('from', from);
                if (to) params.append('to', to);
                const queryString = params.toString();
                return `/summary${queryString ? `?${queryString}` : ''}`;
            },
            responseHandler: (response) => response.text()
        }),
    })
});

export const {
    useLazyExportOrdersQuery,
    useLazyExportExpensesQuery,
    useLazyExportSummaryQuery
} = ExportApi;
